export default __webpack_public_path__ + "static/media/sunsetHills.846f8004.gif";